import React from 'react';
import { Box, Paper, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { serviceInfo } from '../components/shared/Content';

const ServiceInfoCard = () => (
    <Paper
        className="b-container-content"
        id='this-that-paper-son'
        style={{ inlineSize: 'unset' }}
        disablePadding
        sx={{ paddingTop: { xs: '24px', md: '88px' }, paddingBottom: { xs: '24px', md: '88px' } }}
    >
        <Box style={{ padding: 0 }}>
            <Typography
                type="headline" scale={200} bold
                sx={{
                    paddingTop: '8px',
                    paddingBottom: '8px'
                }}
            >
                Important Information about the Retirement Advisory Service (Service):
            </Typography>
            <Box>
                <ul id='service-info-card-list' style={{ paddingLeft: '16px' }}>
                    {serviceInfo.map((key) => (
                        <li key={key.bulletNum} id={`service-info-container-${key.bulletNum}`}>
                            <Typography
                                loose
                                dangerouslySetInnerHTML={{
                                    __html: key.text,
                                }}
                            />
                        </li>
                    ))}
                </ul>
            </Box>
        </Box>
    </Paper>
);
export default ServiceInfoCard;
